import client from "./client";

const endpoint = "/hotels/";

export const getAllHotels = () => client.get(endpoint);

export const getHotelsBySearch = (searchTerm) => client.get(`${endpoint}/?search=${searchTerm}`);
